

import { Component, Prop, Vue } from 'vue-property-decorator'

type UploadFileCallback = (fileToUpload: File) => Promise<boolean>
type PostUploadCallback = (data: any) => Promise<boolean>

@Component({})

// ZipUploaderVue is a modal vue that will show a file picker for a zip file and if valid, will call the UploadFileCallback
// and then PostUploadCallback that are supplied when the modal is shown via the 'show' function.
export default class ZipUploaderVue extends Vue {
  @Prop({ default: '.zip,application/zip,application/x-zip-compressed' })
  public acceptType!: string

  private fileToUpload!: File
  private uploadRules !: any
  private showModal: boolean = false
  private isUploadingFile: boolean = false
  private isFileSelected: boolean = false
  private isUploadValid: boolean = false
  private uploadExternalValidationErrors: string[] = []
  private filename: any = null

  private callbackUploadFile!: UploadFileCallback
  private callbackPostUploadFile!: PostUploadCallback | null

  public get IsShowingDialog(): boolean {
    return this.showModal
  }

  private static readonly ZipFileUploadRule: any = [(v: any) => !v || v.type === 'application/zip' || 'File must be a .zip']

  protected async created() {
    this.uploadRules = ZipUploaderVue.ZipFileUploadRule
  }

  public Init() {
    if (this.showModal) {
      // Can't init while using dialog
      return
    }
  }

  public Show(
    callbackUploadFile: UploadFileCallback,
    callbackPostUpload: PostUploadCallback | null
  ) {
    this.isFileSelected = false
    this.filename = null
    this.callbackUploadFile = callbackUploadFile
    this.callbackPostUploadFile = callbackPostUpload
    if (this.callbackUploadFile === null) {
      return
    }
    this.showModal = true
  }

  public Hide() {
    if (!this.isUploadingFile) {
      this.showModal = false
    }
  }

  private async uploadFileClick() {
    this.isUploadingFile = true
    if (await this.callbackUploadFile(this.fileToUpload)) {
      if (this.callbackPostUploadFile !== null && typeof this.callbackPostUploadFile === 'function') {
        await this.callbackPostUploadFile(null)
      }
    }
    this.isUploadingFile = false
    this.showModal = false
  }

  private async onFileInputChange(file: File) {
    this.uploadExternalValidationErrors = []
    if (file && file.size) {
      this.fileToUpload = file
      this.isFileSelected = true
      this.isUploadValid = true
    } else {
      this.isFileSelected = false
    }
  }
}
